import { useMemo } from 'react';
import { useIsMobile } from '@/hooks/use-mobile';

interface RevealViewport {
  isMobile: boolean;
  isTablet: boolean;
  /** Multiply all phase durations by this */
  timingMultiplier: number;
  /** Y origin for CinematicBurst (percentage) */
  burstOriginY: number;
  /** Reduce particle / decoration counts by this factor (1 = full, 0.5 = half) */
  particleScale: number;
}

export function useRevealViewport(): RevealViewport {
  const isMobile = useIsMobile(); // < 768

  return useMemo(() => {
    const w = typeof window !== 'undefined' ? window.innerWidth : 1024;
    const isTablet = !isMobile && w < 1024;

    if (isMobile) {
      // Phase 4 — mobile pacing brought closer to desktop so the emotional
      // beats actually land (was 0.55, felt rushed on small screens).
      return { isMobile: true, isTablet: false, timingMultiplier: 0.8, burstOriginY: 35, particleScale: 0.5 };
    }
    if (isTablet) {
      return { isMobile: false, isTablet: true, timingMultiplier: 0.88, burstOriginY: 40, particleScale: 0.7 };
    }
    return { isMobile: false, isTablet: false, timingMultiplier: 1, burstOriginY: 45, particleScale: 1 };
  }, [isMobile]);
}

/** Mobile-only preparing indicator component (import in scenes) */
export { default as PreparingIndicator } from './PreparingIndicator';
